import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  darkMode: false,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,

  reducers: {
    toggleMode: (state, action) => {
      state.darkMode = !state.darkMode;
    },
  },
});

export const { darkMode, toggleMode } = themeSlice.actions;

export default themeSlice.reducer;
